import { createSelector } from 'reselect';
import FluxVolumeOeReportColumns from '../../containers/FluxVolumeOeReportColumns';
import FluxVolumeOeReportTotalColumns from '../../containers/FluxVolumeOeReportTotalColumns';
import { getTotal, getAvg } from '../../../../react-table/helpers/calculateTotal';
import TableDefinitions from '../../../../../common/TableDefinitions';

export const getIsLoading = (state) => state.listing.REPORTING_FLUX_VOLUME_OE.isLoading;
export const getData = TableDefinitions.REPORTING_FLUX_VOLUME_OE.getDataFunction();
export const getFilteredData = (state) => state.listing.REPORTING_FLUX_VOLUME_OE.filteredData;
export const getColumns = createSelector(getData, FluxVolumeOeReportColumns);
export const getTotalData = createSelector(
  getData,
  (data) => {
    if (!data.length) {
      return [];
    }
    return [
      { name: 'Total', ...getTotal(data) },
      { name: 'Avg', ...getAvg(data) },
    ];
  },
);
export const getTotalFilteredData = createSelector(
  (state) => state.listing.REPORTING_FLUX_VOLUME_OE.filteredData,
  (data) => [
  { name: 'Total', ...getTotal(data) },
  { name: 'Avg', ...getAvg(data) },
],
);
export const getTotalColumns = createSelector(getData, FluxVolumeOeReportTotalColumns);
